import {
    faDownload,
    faMagnifyingGlassMinus,
    faMagnifyingGlassPlus,
    faReflectHorizontal,
    faReflectVertical,
    faRotateBackward,
    faRotateForward,
    faTrashAlt,
    faWindowRestore,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popconfirm } from "antd";

interface WaypointStepAttachmentPreviewToolBarProps {
    onDownload?: () => void;
    onFlipY?: () => void;
    onFlipX?: () => void;
    onRotateLeft?: () => void;
    onRotateRight?: () => void;
    onZoomOut?: () => void;
    onZoomIn?: () => void;
    onReset?: () => void;
    onDelete?: () => void;
}

export default function WaypointStepAttachmentPreviewToolBar({
    onDownload,
    onFlipY,
    onFlipX,
    onRotateLeft,
    onRotateRight,
    onZoomOut,
    onZoomIn,
    onReset,
    onDelete,
}: WaypointStepAttachmentPreviewToolBarProps) {
    const iconSize = "2x";
    const buttonClassNames = "cursor-pointer hover:scale-120 transition-transform duration-200";
    return (
        <div className="flex flex-row items-center gap-4">
            {onDownload && (
                <button type="button" onClick={onDownload} className={buttonClassNames}>
                    <FontAwesomeIcon icon={faDownload} size={iconSize} />
                </button>
            )}
            <button type="button" onClick={onFlipY} className={buttonClassNames}>
                <FontAwesomeIcon icon={faReflectVertical} size={iconSize} />
            </button>
            <button type="button" onClick={onFlipX} className={buttonClassNames}>
                <FontAwesomeIcon icon={faReflectHorizontal} size={iconSize} />
            </button>
            <button type="button" onClick={onRotateLeft} className={buttonClassNames}>
                <FontAwesomeIcon icon={faRotateBackward} size={iconSize} />
            </button>
            <button type="button" onClick={onRotateRight} className={buttonClassNames}>
                <FontAwesomeIcon icon={faRotateForward} size={iconSize} />
            </button>
            <button type="button" onClick={onZoomOut} className={buttonClassNames}>
                <FontAwesomeIcon icon={faMagnifyingGlassMinus} size={iconSize} />
            </button>
            <button type="button" onClick={onZoomIn} className={buttonClassNames}>
                <FontAwesomeIcon icon={faMagnifyingGlassPlus} size={iconSize} />
            </button>
            <button type="button" onClick={onReset} className={buttonClassNames}>
                <FontAwesomeIcon icon={faWindowRestore} size={iconSize} />
            </button>
            {onDelete && (
                <Popconfirm title="Are you sure you want to delete this attachment?" onConfirm={onDelete}>
                    <button type="button" className={buttonClassNames}>
                        <FontAwesomeIcon icon={faTrashAlt} size={iconSize} />
                    </button>
                </Popconfirm>
            )}
        </div>
    );
}
